

























































































import Vue from 'vue';
import axios from 'axios';

export default Vue.extend({
  name: 'SettingsCars',
  data: () => ({
    tableData: [],
    modalEdit: false,
    modalDelete: false,
    validForm: false,
    search: '',
    userGroup: {
      ID: 0,
      name: '',
      description: '',
    },
    headers: [
      { text: 'Název', value: 'name', width: '25%' },
      { text: 'Popis', value: 'description' },
      { sortable: false, width: '48px' },
    ],
    rules: {
      required: (value: string) => !!value || 'Pole je povinné',
      number: (value: string) => {
        const pattern = /^\d+$/;
        return pattern.test(value) || 'Hodnota musí být číslo!!!';
      },
    },
  }),
  watch: {},
  mounted() {
    this.dataLoad();
  },
  methods: {
    dataLoad() {
      axios
        .get('/api/v1/group')
        .then((response) => {
          this.tableData = response.data;
        })
        .catch((err) => {
          this.$store.dispatch('catchErrHandler', err);
        });
    },
    dataNew() {
      this.userGroup = {
        ...this.userGroup,
        ...((this.$options as Vue & { data: () => object }).data() as Vue & { userGroup: object }).userGroup,
      };
      this.modalEdit = true;
      this.$nextTick(function () {
        (this.$refs.userGroupForm as Vue & { validate: () => boolean }).validate();
      });
    },
    dataSave() {
      if ((this.$refs.userGroupForm as Vue & { validate: () => boolean }).validate() !== true) {
        this.$store.commit('globalMessage', 'Formulář obsahuje chyby!!!');
      } else {
        if (this.userGroup.ID === 0) {
          axios
            .post('/api/v1/group', this.userGroup)
            .then(() => {
              this.dataLoad();
              this.modalEdit = false;
            })
            .catch((err) => {
              this.$store.dispatch('catchErrHandler', err);
            });
        } else {
          axios
            .put(`/api/v1/group/${this.userGroup.ID}`, this.userGroup)
            .then(() => {
              this.dataLoad();
              this.modalEdit = false;
            })
            .catch((err) => {
              this.$store.dispatch('catchErrHandler', err);
            });
        }
      }
    },
    dataDelete() {
      axios
        .delete(`/api/v1/group/${this.userGroup.ID}`)
        .then(() => {
          this.dataLoad();
        })
        .catch((err) => {
          this.$store.dispatch('catchErrHandler', err);
        });
      this.modalEdit = false;
      this.modalDelete = false;
    },
  },
});
